import { FileType } from '..';

export const getImageUrl = (image: File, func: (url: FileType) => void): void => {
	const reader = new FileReader();

	reader.onload = () => func(reader.result);
	reader.readAsDataURL(image);
};
